import { render, staticRenderFns } from "./PosCounterBody.vue?vue&type=template&id=615f69f0&scoped=true"
import script from "./PosCounterBody.vue?vue&type=script&lang=js"
export * from "./PosCounterBody.vue?vue&type=script&lang=js"
import style0 from "./PosCounterBody.vue?vue&type=style&index=0&id=615f69f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f69f0",
  null
  
)

export default component.exports